<template>
  <div class="document-style">
    <ul style="margin-block-start: 8px" class="fs-16">
      <li>
        <div class="title-list-style">
          <span>Character & Key</span>
        </div>
        <div class="mt-12">
          <div
            v-for="value in dimension"
            :key="value.dimpic"
            class="flex mb-12"
          >
            <img
              v-lazy="getImgUrlDim(value.dimpic)"
              class="image-skeleton image-profile-32"
            />
            <div style="line-height: 14px">
              <div class="ml-12 mt-2">
                {{ value.name }}
                <span class="opa-07">- {{ value.characterName }}</span>
              </div>
              <div class="ml-12 opa-06 fs-12">
                {{ value.quest_name }}
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
        
  <script>
export default {
  data() {
    return {
      dimension: [
        {
          quest_id: "-Kgs61AHOnpJ3rfyQr6t",
          category_id: "-KxQjHv0aMgv6TWNWemH",
          name: "Happiness",
          quest_name: "How do you feel today at the office?",
          dimpic: "Happiness@2x",
          characterName: "Harry",
        },
        {
          quest_id: "-Kgn7oxLPPWlbM_ZDc_h",
          category_id: "-KxRdFigA6geGzv2zJHQ",
          name: "Personal Growth",
          quest_name: "How would you rate your opportunities for growth?",
          dimpic: "Personal-Growth@2x",
          characterName: "Polly",
        },
        {
          quest_id: "-L0J5FFsGQYVkfcGujWo",
          category_id: "-KxRwgLlN0DpB0p7al7N",
          name: "Recognition",
          quest_name: "Have you gotten any recognition in the last 7 days?",
          dimpic: "Recognition@2x",
          characterName: "Rain",
        },
        {
          quest_id: "-Kgs549ClADmNQwoNbbG",
          category_id: "-KxRyiIXeDebHreB12mM",
          name: "Relationship with Colleagues",
          quest_name:
            "How would you rate the level of respect colleagues give to each other in your workplace?",
          dimpic: "Rel.Colleagues@2x",
          characterName: "Ron", // Ron & Reef
        },
        {
          quest_id: "-L1FmpFO-v8IZc_B5EB7",
          category_id: "-KxRzHeGK7cuwKtAKQwF",
          name: "Satisfaction",
          quest_name: "Do you feel challenged at work?",
          dimpic: "Satisfaction@2x",
          characterName: "Sam",
        },
        {
          quest_id: "-L2ycGiBDo3rDGjLNKwW",
          category_id: "-KxRzbMWTgeqpsSbCo_6",
          name: "Ambassadorship",
          quest_name: "Do you see yourself working here one year from now?",
          dimpic: "Ambassadorship@2x",
          characterName: "Amy",
        },
        {
          quest_id: "-L1QWPtZvax_KlJgpNxF",
          category_id: "-KxS-JNn6sNeqTD0KE53",
          name: "Feedback",
          quest_name: "Do you think you get enough feedback?",
          dimpic: "Feedback@2x",
          characterName: "Freddie",
        },
        {
          quest_id: "-L1Qug-PhtzVOR2Dr5q7",
          category_id: "-KxS-e4O2--BrGiRWbEF",
          name: "Relationship with Managers",
          quest_name:
            "In the past 7 days, have you interacted with your manager?",
          dimpic: "Rel.Manager@2x",
          characterName: "Max",
        },
        {
          quest_id: "-L36rxTgLhZTL4mq4SV1",
          category_id: "-KxS05m9KaS70Ai6ps93",
          name: "Wellness",
          quest_name:
            "In the past 7 days, have you felt stressed or overwhelmed at work?",
          dimpic: "Wellness@2x",
          characterName: "Will",
        },
        {
          quest_id: "-LtOL_iR1N-ev2b_8Tmg",
          category_id: "-KxS15s4DhoKSrjs4D7k",
          name: "Company Alignment",
          quest_name:
            "In the past 7 days, have you felt stressed or overwhelmed at work?",
          dimpic: "Company-Alignment@2x",
          characterName: "Coal",
        },
      ],
    };
  },
  methods: {
    getImgUrlDim(pic) {
      var images = require.context(
        "../../../assets/images/dimension/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
  },
};
</script><style lang="scss" scoped></style>